export interface RateLimiter {
  throttle<T>(fn: () => Promise<T>, limit: number): Promise<T>;
  backoff<T>(fn: () => Promise<T>, maxRetries: number): Promise<T>;
}

export class SimpleRateLimiter implements RateLimiter {
  private lastCall: number = 0;

  async throttle<T>(fn: () => Promise<T>, limitMs: number): Promise<T> {
    const now = Date.now();
    const timeSinceLastCall = now - this.lastCall;
    
    if (timeSinceLastCall < limitMs) {
      await new Promise(resolve => setTimeout(resolve, limitMs - timeSinceLastCall));
    }
    
    this.lastCall = Date.now();
    return fn();
  }

  async backoff<T>(fn: () => Promise<T>, maxRetries: number): Promise<T> {
    let lastError: Error;
    
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        lastError = error as Error;
        
        if (attempt === maxRetries) {
          throw lastError;
        }
        
        const delay = Math.min(1000 * Math.pow(2, attempt), 10000);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
    
    throw lastError!;
  }
}